import { Menu, MenuButton, MenuItems } from "@headlessui/react";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";

import { ProjectCardMenuItem, type ProjectCardMenuItemData } from "~/modules/dashboard/components/ProjectCardMenuItem.tsx";

type Props = {
	items: ProjectCardMenuItemData[];
};

// The panel uses `anchor`, so Headless UI renders it in a portal: the card cuts its overflow, and a
// panel inside the card would be cut.
export function ProjectCardMenu({ items }: Props) {
	if (items.length === 0) return null;

	return (
		<Menu>
			<MenuButton aria-label="Weitere Aktionen"
						className="-mr-1 flex size-7 shrink-0 items-center justify-center rounded-md text-gray-500 hover:bg-gray-200 hover:text-gray-700">
				<EllipsisHorizontalIcon aria-hidden className="size-5" />
			</MenuButton>
			<MenuItems anchor="bottom end"
					   className="z-20 w-64 rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none">
				{items.map((item) => <ProjectCardMenuItem key={item.label} {...item} />)}
			</MenuItems>
		</Menu>
	);
}
